import React from 'react';
import { Flex } from '@osmosis/tailwind-ui/components/Box';
import Divider from './Divider';

type Props = {
  children: React.ReactNode;
};

/**
 * Wraps children with dividers.
 */
const DividersWrapper = (props: Props) => {
  const { children } = props;

  return (
    <Flex className="justify-center my-3">
      <Divider cn="h-[2px] flex-1 mr-8" />
      {children}
      <Divider cn="h-[2px] flex-1 ml-8" />
    </Flex>
  );
};

export default DividersWrapper;
